export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-6-934853d75ac4b79be433484fbe4d8f7e.png";